import { createReducer, on } from '@ngrx/store';
import { AppleApplicationApiActions } from './apple-applications.actions';
import { adapter, initialState } from './apple-applications.state';

export const appleApplicationReducer = createReducer(
  initialState,
  on(AppleApplicationApiActions.applicationsLoaded, (state, { applications }) =>
    adapter.upsertMany(applications, state)
  ),
  on(AppleApplicationApiActions.applicationUploadProgressed, (state, { progress }) => ({
    ...state,
    progress: progress,
  })),
  on(AppleApplicationApiActions.applicationAdded, (state, { application }) =>
    adapter.addOne(application, { ...state, progress: null })
  ),
  on(AppleApplicationApiActions.applicationDeleted, (state, { bundleIdentifier, version }) =>
    adapter.removeMany(
      state.ids
        .map((id: string | number) => id.toString())
        .filter((id: string) => id.includes(`${bundleIdentifier}-${version ? version : ''}`)),
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectAppleApplicationIds = selectIds;

export const selectAppleApplicationEntities = selectEntities;

export const selectAllAppleApplications = selectAll;
